// Angular dependecies
import {
  Component,
  Inject,
  OnInit,
  OnDestroy
} from '@angular/core';
import { DOCUMENT } from '@angular/common';

// Rxjs dependencies
import 'rxjs/add/operator/take';
import 'rxjs/add/operator/filter';
import { Observable } from 'rxjs/Observable';
import { Subscription } from 'rxjs/Subscription';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

// Store
import { Store } from '@ngrx/store';
import { AppState } from '../../store.module';

// App dependencies
import { Creep } from '../../creep';


@Component({
  selector: 'app-share',
  templateUrl: './share.component.html',
  styleUrls: ['./share.component.css']
})
export class ShareComponent {
  link$: Observable<string>;
  public showShare: boolean;

  constructor(
    @Inject(DOCUMENT) private document: any,
    private _store: Store<AppState>
  ) {

    this.link$ = this._store
      .select(function(state) {
        return state.creeps.creeps;
      })
      .map((creeps) => {
        return creeps
          .map((creep: Creep) => '' + creep)
          .join(',');
      })
      .map((link) => `${ this.document.baseURI }?creeps=${ link }`);
  }

  onCopy(event, shareLinkRef: HTMLElement) {
    let textarea: HTMLTextAreaElement = null;
    const value = shareLinkRef.innerHTML;

    try {
      textarea = this.document.createElement( 'textarea' );
      textarea.style.opacity = '0';
      textarea.style.position = 'fixed';
      textarea.style.top = '-100px';
      textarea.style.left = '-100px';
      textarea.style.width = '0px';
      textarea.style.height = '0px';
      this.document.body.appendChild( textarea );

      // Set and select the value (creating an active Selection range).
      textarea.value = value;
      textarea.select();

      // Ask the browser to copy the current selection to the clipboard.
      this.document.execCommand( 'copy' );
    } finally {
      // Cleanup - remove the Textarea from the DOM if it was injected.
      if ( textarea && textarea.parentNode ) {
        textarea.parentNode.removeChild( textarea );
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/power-planner/power-planner/src/app/core.module/share.component/share.component.ts